module.exports = __webpack_public_path__ + "static/media/Executive Summary_221123.f78aac33.pdf";